module.exports = __webpack_public_path__ + "img/certificate.0c8b6428.jpg";